module.exports = __webpack_public_path__ + "static/img/aepic-26-2.5373c12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/aepic/aepic-26-2.jpg
// module id = Bmah
// module chunks = 51